/* GOPSHOP – Neuheiten-Tabs (sections/gop-tabs.liquid)
   Blendet die Ziel-Bereiche ein/aus (nur einer sichtbar). 3D-Bereiche pausieren von selbst, wenn sie
   versteckt sind (IntersectionObserver). Links auf versteckte Bereiche (/#gop-dyson) öffnen den passenden Tab.
   window.gopReveal(id) → Tab mit diesem Bereich aktivieren (genutzt von gop-stories.js). */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function findSection(t) {
    t = String(t || '').trim();
    if (!t) return null;
    var el = document.getElementById(t);
    if (el) return el.closest('.shopify-section') || el;
    try {
      return document.querySelector('.shopify-section[id$="__' + t.replace(/[^\w-]/g, '') + '"]');
    } catch (e) {
      return null;
    }
  }

  function init(root) {
    if (root.__gtb) {
      root.__gtb.refresh();
      return;
    }
    var api = {};
    root.__gtb = api;
    var bar = root.querySelector('[role="tablist"]');
    var ind = root.querySelector('[data-gtb-ind]');
    var items = [];
    var cur = -1;

    function resolve() {
      items = [];
      root.querySelectorAll('[data-gtb-tab]').forEach(function (btn) {
        var sec = findSection(btn.getAttribute('data-target'));
        if (!sec || sec.contains(root)) {
          btn.hidden = true;
          return;
        }
        btn.hidden = false;
        items.push({ btn: btn, sec: sec });
        sec.classList.add('gtb-panel');
        sec.setAttribute('role', 'tabpanel');
        sec.setAttribute('aria-labelledby', btn.id);
        if (sec.id) btn.setAttribute('aria-controls', sec.id);
      });
      root.classList.toggle('is-ready', items.length > 0);
    }

    function moveInd() {
      if (cur < 0 || !ind || !items[cur]) return;
      var b = items[cur].btn;
      ind.style.width = b.offsetWidth + 'px';
      ind.style.transform = 'translate3d(' + b.offsetLeft + 'px,0,0)';
    }

    function select(i, anim) {
      if (i < 0 || i >= items.length || i === cur) return;
      cur = i;
      items.forEach(function (x, j) {
        var on = j === i;
        x.btn.setAttribute('aria-selected', String(on));
        x.btn.tabIndex = on ? 0 : -1;
        x.sec.classList.toggle('gtb-off', !on);
        if (on && anim && !reduce) {
          x.sec.classList.remove('gtb-in');
          void x.sec.offsetWidth;
          x.sec.classList.add('gtb-in');
        }
      });
      moveInd();
      /* 3D-Bereiche messen ihre Größe neu, sobald sie sichtbar werden */
      window.dispatchEvent(new Event('resize'));
    }

    function indexOf(el) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].sec === el || items[i].sec.contains(el) || items[i].btn === el) return i;
      }
      return -1;
    }

    api.reveal = function (el) {
      var i = indexOf(el);
      if (i >= 0) select(i, false);
      return i >= 0;
    };

    api.refresh = function () {
      var keep = cur;
      cur = -1;
      resolve();
      if (items.length) select(Math.min(Math.max(keep, 0), items.length - 1), false);
    };

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gtb-tab]');
      if (!b) return;
      select(indexOf(b), true);
      if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
    });

    if (bar) {
      bar.addEventListener('keydown', function (e) {
        var n = -1;
        if (e.key === 'ArrowRight') n = (cur + 1) % items.length;
        else if (e.key === 'ArrowLeft') n = (cur - 1 + items.length) % items.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = items.length - 1;
        if (n < 0) return;
        e.preventDefault();
        select(n, true);
        items[n].btn.focus();
      });
    }

    window.addEventListener('resize', moveInd);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(moveInd);

    resolve();
    if (!items.length) return;
    /* Start: Tab passend zum #Anker in der Adresse, sonst der erste */
    var start = 0;
    var h = window.location.hash.slice(1);
    if (h) {
      var el = document.getElementById(h) || findSection(h);
      if (el && indexOf(el) >= 0) start = indexOf(el);
    }
    select(start, false);
  }

  window.gopReveal = function (id) {
    var el = document.getElementById(id) || findSection(id);
    if (!el) return null;
    document.querySelectorAll('[data-gop-tabs]').forEach(function (r) {
      if (r.__gtb) r.__gtb.reveal(el);
    });
    return el;
  };

  /* Klick auf einen Link zu einem versteckten Bereich → erst Tab öffnen, dann springt der Browser hin */
  document.addEventListener(
    'click',
    function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var id = href.slice(href.indexOf('#') + 1);
      if (!id || /[=&?/]/.test(id)) return;
      var el = document.getElementById(id);
      if (el && el.closest('.gtb-off')) window.gopReveal(id);
    },
    true
  );

  window.addEventListener('hashchange', function () {
    var id = window.location.hash.slice(1);
    if (!id || /[=&?/]/.test(id)) return;
    var el = window.gopReveal(id);
    if (el) el.scrollIntoView({ block: 'start' });
  });

  function boot() {
    document.querySelectorAll('[data-gop-tabs]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme-Editor: neu geladene Bereiche wieder einsortieren, ausgewählten Bereich zeigen */
  document.addEventListener('shopify:section:load', function () {
    setTimeout(boot, 0);
  });
  document.addEventListener('shopify:section:select', function (e) {
    document.querySelectorAll('[data-gop-tabs]').forEach(function (r) {
      if (r.__gtb) r.__gtb.reveal(e.target);
    });
  });
})();
